import { configureSlices } from "utils/store/configureSlices";

import chatDraftAttachmentsSlice from "./chatDraftFilesSlice";
import conversationsSlice from "./conversationsSlice";

export const { useSlices: useChatSlices, useSliceSelector: useChatSliceSelector } = configureSlices({
  chatDraftAttachmentsSlice,
  conversationsSlice,
});
